import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, filter, tap } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CodeEditor } from '@acrodata/code-editor';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { JSON_EDITOR_EXTENSIONS, JSON_EDITOR_INDENT_UNIT } from '@parashift/shared/constants';

@Component({
    selector: 'codemirror-field',
    templateUrl: './codemirror-field.component.html',
    imports: [
    AsyncPipe,
    CodeEditor,
    ReactiveFormsModule,
    FormsModule,
    FormlyModule
]
})
export class CodemirroFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  private destroyRef = inject<DestroyRef>(DestroyRef);

  readonly jsonEditorExtensions = JSON_EDITOR_EXTENSIONS;
  readonly jsonEditorIndentUnit = JSON_EDITOR_INDENT_UNIT;

  private _code$ = new BehaviorSubject<string>('');
  readonly code$ = this._code$.asObservable();

  private _showEditor$ = new BehaviorSubject<boolean>(false);
  readonly showEditor$ = this._showEditor$.asObservable();

  constructor() {
    super();
  }

  ngOnInit() {
    this._showEditor$.next(!this.field?.hide)
    this._code$.next(this.formControl?.value);
    this.listenToHideEvents();
  }

  onCodeChanged(code: string) {
    this.formControl.patchValue(code);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
  }

  private listenToHideEvents() {
    this.field?.options.fieldChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      filter(changeEvent => {
        return changeEvent.type === 'expressionChanges'
          && changeEvent.field === this.field
          && changeEvent.property === 'hide'
      }),
      tap(changeEvent => this._showEditor$.next(!changeEvent.value))
    ).subscribe();
  }
}
